import { render, staticRenderFns } from "./depositHistory.vue?vue&type=template&id=0b240976"
import script from "./depositHistory.vue?vue&type=script&lang=js"
export * from "./depositHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports